import { Box } from "@mantine/core";
import AskDoubts from "../../../packages/ui2/components/AskDoubts";

const Doubts = () => {
    return (
        <Box>
            <AskDoubts />
        </Box>
    );
};

export default Doubts;
